module.exports = __webpack_public_path__ + "static/img/3.b078984.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/productStage/3.png
// module id = JAfw
// module chunks = 44